import { render, staticRenderFns } from "./MenuUserAvatar.vue?vue&type=template&id=a3d5c0aa&scoped=true"
import script from "./MenuUserAvatar.vue?vue&type=script&lang=js"
export * from "./MenuUserAvatar.vue?vue&type=script&lang=js"
import style0 from "./MenuUserAvatar.vue?vue&type=style&index=0&id=a3d5c0aa&prod&lang=css"
import style1 from "./MenuUserAvatar.vue?vue&type=style&index=1&id=a3d5c0aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d5c0aa",
  null
  
)

export default component.exports